import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeolocationService } from '../services/geolocationservice';
import { sweetalert } from "../services/sweetalert";

@Component({
  selector: 'app-emicard-geolocation',
  templateUrl: './emicard-geolocation.component.html',
  styleUrls: ['./emicard-geolocation.component.css']
})
export class EmicardGeolocationComponent implements OnInit,AfterViewInit {
  @ViewChild("mapContainer", { static: false }) gmap!: ElementRef;
  
  dealerList:any;
  map!: google.maps.Map;
  lat = 21.7679;
  lng = 78.8718;
  markers:any=[];
  loader:boolean=false;
  responseData:any;
  srcLat:any;
  srcLng:any;

  //Coordinates to set the center of the map
  coordinates = new google.maps.LatLng(this.lat,this.lng);

  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 5
  };

  //Default Marker
  marker = new google.maps.Marker({
    position: this.coordinates,
    map: this.map,
    title: "India"
  });

  constructor(private service: GeolocationService,
    private alert: sweetalert,
    private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      
      this.srcLat= params['lat'].replaceAll('\'', '');
      this.srcLng=params['lng'].replaceAll('\'', '');
      //this.alert.MSG_sweertalert('Source Lat:'+this.srcLat+' Source Lng:'+this.srcLng);

  console.log("saathiLat:"+this.srcLat);
  console.log("saathiLng:"+this.srcLng);
      // localStorage.setItem("mobilenum", this.mobilenum);

      error => {

        console.error("Unable to Process")

      }

    });
  }

  ngAfterViewInit(): void {
    this.mapInitializer(this.mapOptions);
    this.loader=true;
    setTimeout(() => {
      this.loader=false;
    },1000);

    let mymodal = document.getElementById("myModal") as HTMLDivElement;
    setTimeout(() => {
      mymodal.style.display = 'block';
    },1000);

  }

  mapInitializer(mapOptions:any): void {
    this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);

    //Adding Click event to default marker
    this.marker.addListener("click", () => {
      const infoWindow = new google.maps.InfoWindow({
        content: this.marker.getTitle()
      });
      infoWindow.open(this.marker.getMap(), this.marker);
    });
  }
  mapData() {

    this.dealerList.forEach((loc: any) => {

      let lat = loc.lat;
      let lng = loc.lng;

     const marker:any =  {
        position: new google.maps.LatLng(lat,lng),
        map: this.map,
        title: loc.dealerName
      }

      this.markers.push(marker);
    });  
  
  }

  loadAllMarkers(): void {

  
    this.markers.forEach((markerInfo: google.maps.ReadonlyMarkerOptions) => {
      //Creating a new marker object
      const marker = new google.maps.Marker({
        ...markerInfo
      });
      
        let origin=this.srcLat+","+this.srcLng;
        let destination=marker.getPosition().lat()+','+marker.getPosition().lng(); 
        let url='https://www.google.com/maps/dir/?api=1&origin='+origin+'&destination='+destination+'&travelmode=driving';
          //creating a new info window with markers info
          const infoWindow = new google.maps.InfoWindow({
            content: '<div><strong><b>' +
            marker.getTitle() +
            '</b></strong><br>' + 
            `<a href="${url}" target="_blank">View on Google Maps`
            
          });
    
          //Add click event to open info window on marker
          marker.addListener("click", () => {
            infoWindow.open(this.marker.getMap(), marker);
          });  

      //Adding marker to google map
      marker.setMap(this.map);
    });
  }

  close(modal:any){
    let mymodal = document.getElementById(modal) as HTMLDivElement;
      mymodal.style.display = 'none';
  }

  getPortfolio(portfolio:string){
    console.log("portfolio:"+portfolio);
      const currentLocation:any =  {
        lat: this.srcLat,
        lng: this.srcLng
      }
      console.log("currentLocation:"+currentLocation);
      this.loader=true;
      let mymodal = document.getElementById("myModal") as HTMLDivElement;
      mymodal.style.display = 'none';
      this.service.getGeoLocation(currentLocation,portfolio).subscribe(
        (data:any)=>{

          setTimeout(() => {
            this.loader=false;
            if (typeof (data) === 'object') {
              this.responseData=JSON.parse(data.data);
              //console.log("event:"+JSON.stringify(this.responseData))
              
              if(data.statusCode=='ER'){
                this.alert.errorsweertalert(data.statusMessage);
              }
              else if(data.statusCode=='SR'){
                mymodal.style.display = 'none';
                this.dealerList=this.responseData.dealers;
                //console.log("dealerslist:"+JSON.stringify(this.dealerList));
                this.showFirstDealer(this.dealerList[0]);
                let dList = document.getElementById("dealerList") as HTMLDivElement;
                dList.style.display = 'block';
  
                if(this.dealerList!=null){
                  this.mapData();
                  this.loadAllMarkers();
                  
             }
              }else{
                this.alert.errorsweertalert("Something went wrong");
              }
              
            }
          },1000);
          
        }
      );
   
  }
  showFirstDealer(data: any) {
   this.lat=data.lat;
   this.lng=data.lng;

   this. coordinates = new google.maps.LatLng(this.lat,this.lng);

   let mapOptions:google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 16
  };
    this.mapInitializer(mapOptions);
  }

  locatemap(data:any){
   this.lat=data.lat;
   this.lng=data.lng;

   this. coordinates = new google.maps.LatLng(this.lat,this.lng);

   let mapOptions:google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 16
  };

    this.getDirection(this.lat,this.lng);

    this.mapInitializer(mapOptions);
    this.mapData();
    this.loadAllMarkers();
    //this.hidDList=true;
  }


  getDirection(dirLat: any, dirLng: any) {
  
         // @ts-ignore
         Dialog.showMsg(dirLat,dirLng);

         //let origin=this.srcLat+","+this.srcLng;
         //let destination=dirLat+','+dirLng;   
         //console.log('https://www.google.com/maps/dir/?api=1&origin='+origin+'&destination='+destination+'&travelmode=driving','_blank');
         //window.open('https://www.google.com/maps/dir/?api=1&origin='+origin+'&destination='+destination+'&travelmode=driving','_blank');

  }
  isLastData(i:any){
    return i == ((this.dealerList.length)-1) 
    ? false 
    : true;
  }

}
